<template>
    <div class="container-fluid mt-4">

      <div class="row">
          <div class="col-2">
            <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="100"/></span>
            <span v-else><img src="@/assets/images/logo.png" height="100"/></span>
          </div>
          <div class="col-7 mt-2"> 
            <h2 style="color:black;font-weight: 700; " class="text-uppercase mb-1">{{ userData.business }}</h2>
            <b style="color:black;font-size:12px">Location: {{ userData.location }}</b><br>
            <b style="color:black;font-size:12px">Contacts: {{ userData.contact }}</b><br>
            <b style="color:black;font-size:12px">E-mail: {{ userData.email }}</b><br>
            <b style="color:black;font-size:12px">Website: {{ userData.website }}</b>
          </div>
          <div class="col-3 mt-3">
            <span style="color:black;font-size:13px;font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;"> Patient ID: <br> <b style="font-size: 20px;"> {{ this.patient_id }}</b></span>
          </div>
        </div>
        <hr style="border: 1px solid black;">
                
        <center><span style="color: black;font-family: tahoma;font-size:13px" class="text-decoration-underline"><b> PAITENT PROFILE</b></span></center>
      <br><div v-for="item in patients" :key="item.id" class="d-flex justify-content-between">
      <span> Name: <b class=" h6">{{ item.name }} </b></span>
      <span> Sex: <b class=" h6">{{ item.gender }} </b></span>
      <span> Age: <b class=" h6">{{ getAge(item.date_of_birth) }} yrs </b></span>
      <span> Address: <b class=" h6">{{ item.address }} </b></span>
      <span> Telephone: <b class=" h6">0{{ item.telephone }} </b></span>
      </div>

            <div class="container-fluid">
            <h4 class="mt-3" style="color:black">Patient Visits</h4>
                <table class="table table-sm mt-2" style="color: black;" density="compact">
                <thead><tr><th>Category</th><th>Service Name</th><th>Service Price</th></tr></thead>
                <tbody>
                <tr v-for="item in visits" :key="item.id">
                    <td>{{ item.service_category.name }} </td>
                    <td>{{ item.service_name.name }}</td>
                    <td>{{ item.service_price }}</td>
                </tr>
                </tbody>
                </table>
            <h4 class="mt-3" style="color:black">Triage History</h4>
                <table class="table table-sm mt-2" style="color: black;" density="compact">
                <thead><tr><th>Temperature</th><th>Weight</th><th>Height</th><th>Muac</th><th>Blood Pressure</th><th>Pulse</th></tr></thead>
                <tbody>
                    <tr v-for="item in triages" :key="item.id">
                        <td>{{ item.temperature }} ℃</td>
                        <td>{{ item.weight }} Kgs</td>
                        <td>{{ item.height }} cm</td>                                  
                        <td>{{ item.muac }} cm</td>                                  
                        <td>{{ item.bloodpressure }} mmHg</td>                                  
                        <td>{{ item.pulse }} b/min</td>                                 
                    </tr>
                </tbody>
                </table>
            <h4 class="mt-3" style="color:black">Appointments</h4>
                <table class="table table-sm mt-2" style="color: black;" density="compact">
                <thead><tr><th>Person to See</th><th>Appointment Date</th><th>Appointment Time</th></tr></thead>
                <tbody>
                <tr v-for="item in appointments" :key="item.id">
                    <td>{{ item.staff.full_name }} </td>
                    <td>{{ item.appointment_date }}</td>
                    <td>{{ item.appointment_time }}</td>
                </tr>
                </tbody>
                </table>

            <h4 class="mt-3" style="color:black">Prescriptions</h4>
            <table class="table table-sm mt-2" style="color: black;" density="compact">
            <thead><tr><th>Medicine</th><th>Unit</th><th>Price</th></tr></thead>
            <tbody>
              <tr v-for="item in prescriptions" :key="item.id">
                  <td>{{ item.medicine.name }}</td>
                  <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
                  <td>{{ item.totalprice }}</td>
              </tr>
            </tbody>
            </table>
            
            <h4 class="mt-3" style="color:black">Payments</h4>
            <table class="table table-sm mt-2" style="color: black;" density="compact">
              <thead><tr><th>Service total</th><th>Prescriptions</th><th>Amount Paid</th><th>Balance</th></tr></thead>
              <tbody>
                <tr v-for="item in payments" :key="item.id">
                    <td>{{ item.services }} </td>
                    <td>{{ item.prescriptions }}</td>
                    <td>{{ item.paid }}</td>                                  
                    <td>{{ item.balance }} </td>                                  
                </tr>
              </tbody>
              </table>
            </div>
            <div class="mt-3 text-center">
                <h5 style="color: black;" class="my-4 text-center">Signature : .........................</h5>
                <p style="color:black;font-size:13px">Printed by : {{ userData.username }}
                <br> Printed Via Daherz Family Doctors
                <br> www.daherzfamilydoctors.com </p>

                <barcode :value="this.patient_id" height="50" display-value="false"></barcode>

            </div>
        </div>
</template>

<script>
import axios from "axios";
import VueBarcode from 'vue-barcode';

export default {
  components: { 'barcode': VueBarcode },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      patients:[],
      visits:[],
      triages:[],
      appointments:[],
      prescriptions:[],
      payments:[],
      patient_id:'',
    };
  },
  created() {
    this.showpatient();
    this.showvisits();
    this.showtriages();
    this.showappointments();
    this.showprescriptions();
    this.showpayments();
  },
  methods: {
    getAge(dateString){
      let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
      return now.getFullYear() - birth.getFullYear() - beforeBirth;
    },
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    async showpatient(){
      this.patient_id=this.$route.query.id;
      let url = `/patientprofile/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.patients = response.data.patients;
      });
    },
    async showvisits(){
      this.patient_id=this.$route.query.id;
      let url = `/profilevisits/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.visits = response.data.visits;
      });
    },
    async showtriages(){
      this.patient_id=this.$route.query.id;
      let url = `/profiletriages/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.triages = response.data.triages;
      });
    },
    async showappointments(){
      this.patient_id=this.$route.query.id;
      let url = `/patientappointment/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.appointments = response.data.appointments;
      });
    },
    async showprescriptions(){
      this.patient_id=this.$route.query.id;
      let url = `/profileprescriptions/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.prescriptions = response.data.prescriptions;
      });
    },
    async showpayments(){
      this.patient_id=this.$route.query.id;
      let url = `/profilepayments/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.payments = response.data.debts;
      });
    },
  },
  mounted() {
    setTimeout(() => {
        window.print();
        window.onafterprint=this.$router.go(-1);
    }, 5800);
},
};
</script>